// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/fonts/Poppins/Poppins-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/fonts/Poppins/Poppins-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../assets/fonts/Poppins/Poppins-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../assets/fonts/Poppins/Poppins-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@keyframes StatusMenu_slideFromRight__4tlqo {
  from {
    transform: translateX(100%);
  }
  to {
    /* Move to the final position when animation completes */
    transform: translateX(0);
  }
}
@keyframes StatusMenu_slideIn__sm8yz {
  from {
    transform: translate(-50%, -200%);
    opacity: 0;
  }
  to {
    transform: translate(-50%, -50%);
    opacity: 1;
  }
}
:root {
  --primary-color-100: #d5eafc;
  --primary-color-200: #abd4fa;
  --primary-color-300: #80bff7;
  --primary-color-400: #3e9cf4;
  --primary-color-500: #1480e1;
  --primary-color-600: #0c6dc7;
  --primary-color-700: #0a579f;
  --primary-color-800: #074177;
  --primary-color-900: #052c50;
  --primary-color-1000: #021628;
  --red-color-100: #ffebeb;
  --red-color-200: #ffcccc;
  --red-color-300: #ffb2b2;
  --red-color-400: #fa8989;
  --red-color-500: #f84f4f;
  --red-color-600: #ee3939;
  --red-color-700: #cc2937;
  --red-color-800: #992730;
  --red-color-900: #661414;
  --red-color-1000: #2f0404;
  --orange-color-100: #fff3eb;
  --orange-color-200: #ffe0cc;
  --orange-color-300: #ffd3b2;
  --orange-color-400: #fab784;
  --orange-color-500: #ff9433;
  --orange-color-600: #f26d0d;
  --orange-color-700: #c5591c;
  --orange-color-800: #9b4b1e;
  --orange-color-900: #663714;
  --orange-color-1000: #331500;
  --yellow-color-100: #fffaeb;
  --yellow-color-200: #fff2cc;
  --yellow-color-300: #ffecb2;
  --yellow-color-400: #fae08f;
  --yellow-color-500: #f7d53b;
  --yellow-color-600: #f5c400;
  --yellow-color-700: #d29700;
  --yellow-color-800: #b0820d;
  --yellow-color-900: #745302;
  --yellow-color-1000: #322401;
  --green-color-100: #f5feec;
  --green-color-200: #e5fccf;
  --green-color-300: #d5faaf;
  --green-color-400: #c1f091;
  --green-color-500: #96dd3c;
  --green-color-600: #75c322;
  --green-color-700: #5ba718;
  --green-color-800: #4e8b19;
  --green-color-900: #3f6614;
  --green-color-1000: #1a2b08;
  --blue-color-100: #ecf5fe;
  --blue-color-200: #cfe5fc;
  --blue-color-300: #afd6fa;
  --blue-color-400: #90caf5;
  --blue-color-500: #59aef8;
  --blue-color-600: #3b9ef7;
  --blue-color-700: #2b7bd4;
  --blue-color-800: #2a619d;
  --blue-color-900: #143f66;
  --blue-color-1000: #021b31;
  --purple-color-100: #f4ecfe;
  --purple-color-200: #e3cffc;
  --purple-color-300: #d0b0fb;
  --purple-color-400: #c198f8;
  --purple-color-500: #b06ef7;
  --purple-color-600: #944af5;
  --purple-color-700: #7231d7;
  --purple-color-800: #5828a1;
  --purple-color-900: #381466;
  --purple-color-1000: #160132;
  --neutral-color-0: #ffffff;
  --neutral-color-10: #f7f9fc;
  --neutral-color-20: #eef2f7;
  --neutral-color-30: #e3eaf2;
  --neutral-color-40: #c8d3e0;
  --neutral-color-50: #91a0b5;
  --neutral-color-60: #6c7a8b;
  --neutral-color-70: #4c5562;
  --neutral-color-80: #373d47;
  --neutral-color-90: #2d333b;
  --neutral-color-100: #24282e;
  --neutral-color-110: #191c1f;
  --neutral-color-120: #0d1011;
  --grey-color-10: #f5f6f7;
  --grey-color-20: #ebecef;
  --grey-color-30: #d7dade;
  --grey-color-40: #c2c7ce;
  --grey-color-50: #aeb5bd;
  --grey-color-60: #9298a0;
  --grey-color-70: #7b828a;
  --grey-color-80: #5c6168;
  --grey-color-90: #3e4145;
  --grey-color-100: #1f2023;
  --opacity-primary-10: rgba(25, 138, 240, 0.1);
  --opacity-primary-20: rgba(25, 138, 240, 0.2);
  --opacity-primary-30: rgba(25, 138, 240, 0.3);
  --opacity-primary-40: rgba(25, 138, 240, 0.4);
  --opacity-primary-50: rgba(25, 138, 240, 0.5);
  --opacity-primary-60: rgba(25, 138, 240, 0.6);
  --opacity-primary-70: rgba(25, 138, 240, 0.7);
  --opacity-primary-80: rgba(25, 138, 240, 0.8);
  --opacity-primary-90: rgba(25, 138, 240, 0.9);
  --opacity-red-10: rgba(242, 84, 84, 0.1);
  --opacity-red-20: rgba(242, 84, 84, 0.2);
  --opacity-red-30: rgba(242, 84, 84, 0.3);
  --opacity-red-40: rgba(242, 84, 84, 0.4);
  --opacity-red-50: rgba(242, 84, 84, 0.5);
  --opacity-red-60: rgba(242, 84, 84, 0.6);
  --opacity-red-70: rgba(242, 84, 84, 0.7);
  --opacity-red-80: rgba(242, 84, 84, 0.8);
  --opacity-red-90: rgba(242, 84, 84, 0.9);
  --opacity-neutral-10: rgba(145, 160, 181, 0.1);
  --opacity-neutral-20: rgba(145, 160, 181, 0.2);
  --opacity-neutral-30: rgba(145, 160, 181, 0.3);
  --opacity-neutral-40: rgba(145, 160, 181, 0.4);
  --opacity-neutral-50: rgba(145, 160, 181, 0.5);
  /* primary tokens */
  --primary-default: var(--primary-color-600);
  --primary-hover: var(--primary-color-700);
  --primary-active: var(--primary-color-800);
  --primary-disabled: var(--neutral-color-40);
  /* background */
  --background-primary: var(--neutral-color-0);
  --background-secondary: var(--neutral-color-0);
  --background-tertiary: var(--neutral-color-10);
  --background-quaternary: var(--neutral-color-10);
  --background-quaternary: var(--neutral-color-30);
  --background-hover: var(--opacity-neutral-10);
  --background-active: var(--opacity-primary-10);
  --background-disabled: var(--neutral-color-10);
  --background-tinted: var(--blue-color-100);
  --background-danger: var(--red-color-100);
  --background-danger-active: var(--opacity-red-10);
  /* border tokens  */
  --border-primary: var(--neutral-color-50);
  --border-secondary: var(--neutral-color-40);
  --border-tertiary: var(--neutral-color-30);
  --border-quaternary: var(--neutral-color-20);
  --border-hover: var(--primary-color-500);
  --border-active: var(--primary-color-500);
  --border-danger: var(--red-color-600);
  --border-disabled: var(--neutral-color-40);
  /* text tokens  */
  --text-primary: var(--grey-color-100);
  --text-secondary: var(--grey-color-70);
  --text-tertiary: var(--grey-color-60);
  --text-disabled: var(--neutral-color-40);
  --text-danger: var(--red-color-600);
  --text-on-color: var(--neutral-color-0);
  --text-on-color-disabled: var(--neutral-color-0);
  --text-link: var(--primary-color-500);
  /* icon tokens  */
  --icon-primary: var(--neutral-color-60);
  --icon-emphasis: var(--neutral-color-110);
  --icon-accent: var(--primary-color-500);
  --icon-disabled: var(--neutral-color-40);
  --icon-on-color: var(--neutral-color-0);
  --icon-color-disabled: var(--neutral-color-0);
  /* support tokens  */
  --support-danger-default: var(--red-color-600);
  --support-danger-hover: var(--red-color-700);
  --support-danger-active: var(--red-color-800);
  --support-approve-default: var(--green-color-600);
  --support-approve-hover: var(--green-color-700);
  --support-approve-active: var(--green-color-800);
  /* status tokens  */
  --status-success: var(--green-color-600);
  --status-warning: var(--yellow-color-600);
  --status-information: var(--blue-color-600);
  --status-danger: var(--red-color-600);
  --status-disabled: var(--neutral-color-50);
  /* Accent Tokens  */
  --accent-red-primary: var(--red-color-600);
  --accent-red-secondary: var(--red-color-300);
  --accent-red-tertiary: var(--red-color-100);
  --accent-red-label: var(--neutral-color-0);
  --accent-orange-primary: var(--orange-color-600);
  --accent-orange-secondary: var(--orange-color-300);
  --accent-orange-tertiary: var(--orange-color-100);
  --accent-orange-label: var(--neutral-color-0);
  --accent-yellow-primary: var(--yellow-color-600);
  --accent-yellow-secondary: var(--yellow-color-300);
  --accent-yellow-tertiary: var(--yellow-color-100);
  --accent-yellow-label: var(--neutral-color-0);
  --accent-green-primary: var(--green-color-600);
  --accent-green-secondary: var(--green-color-300);
  --accent-green-tertiary: var(--green-color-100);
  --accent-green-label: var(--neutral-color-0);
  --accent-blue-primary: var(--blue-color-600);
  --accent-blue-secondary: var(--blue-color-300);
  --accent-blue-tertiary: var(--blue-color-100);
  --accent-blue-label: var(--neutral-color-0);
  --accent-purple-primary: var(--purple-color-600);
  --accent-purple-secondary: var(--purple-color-300);
  --accent-purple-tertiary: var(--purple-color-100);
  --accent-purple-label: var(--neutral-color-0);
  --accent-grey-primary: var(--neutral-color-50);
  --accent-grey-secondary: var(--neutral-color-30);
  --accent-grey-tertiary: var(--neutral-color-10);
  --accent-grey-label: var(--neutral-color-0);
  /* overlay tokens  */
  --overlay-primary: rgba(36, 40, 46, 0.1);
  --overlay-secondary: rgba(36, 40, 46, 0.3);
}

@media (prefers-color-scheme: dark) {
  :root {
    /* primary tokens */
    --primary-default: var(--primary-color-500);
    --primary-hover: var(--primary-color-600);
    --primary-active: var(--primary-color-700);
    --primary-disabled: var(--neutral-color-80);
    /* background */
    --background-primary: var(--neutral-color-120);
    --background-secondary: var(--neutral-color-110);
    --background-tertiary: var(--neutral-color-110);
    --background-quaternary: var(--neutral-color-100);
    --background-quaternary: var(--neutral-color-80);
    --background-hover: var(--opacity-neutral-10);
    --background-active: var(--opacity-primary-20);
    --background-disabled: var(--neutral-color-110);
    --background-tinted: var(--blue-color-1000);
    --background-danger: var(--red-color-1000);
    --background-danger-active: var(--opacity-red-20);
    /* border tokens  */
    --border-primary: var(--neutral-color-60);
    --border-secondary: var(--neutral-color-80);
    --border-tertiary: var(--neutral-color-100);
    --border-quaternary: var(--neutral-color-110);
    --border-hover: var(--primary-color-400);
    --border-active: var(--primary-color-400);
    --border-danger: var(--red-color-500);
    --border-disabled: var(--neutral-color-80);
    /* text tokens  */
    --text-primary: var(--grey-color-20);
    --text-secondary: var(--grey-color-60);
    --text-tertiary: var(--grey-color-80);
    --text-disabled: var(--neutral-color-80);
    --text-danger: var(--red-color-500);
    --text-on-color: var(--neutral-color-0);
    --text-on-color-disabled: var(--neutral-color-120);
    --text-link: var(--primary-color-400);
    /* icon tokens  */
    --icon-primary: var(--grey-color-50);
    --icon-emphasis: var(--neutral-color-10);
    --icon-accent: var(--primary-color-400);
    --icon-disabled: var(--neutral-color-80);
    --icon-on-color: var(--neutral-color-0);
    --icon-color-disabled: var(--neutral-color-80);
    /* support tokens  */
    --support-danger-default: var(--red-color-500);
    --support-danger-hover: var(--red-color-600);
    --support-danger-active: var(--red-color-700);
    --support-approve-default: var(--green-color-600);
    --support-approve-hover: var(--green-color-700);
    --support-approve-active: var(--green-color-800);
    /* status tokens  */
    --status-success: var(--green-color-500);
    --status-warning: var(--yellow-color-500);
    --status-information: var(--blue-color-500);
    --status-danger: var(--red-color-500);
    --status-disabled: var(--neutral-color-50);
    /* Accent Tokens  */
    --accent-red-primary: var(--red-color-500);
    --accent-red-secondary: var(--red-color-900);
    --accent-red-tertiary: var(--red-color-1000);
    --accent-red-label: var(--red-color-1000);
    --accent-orange-primary: var(--orange-color-500);
    --accent-orange-secondary: var(--orange-color-900);
    --accent-orange-tertiary: var(--orange-color-1000);
    --accent-orange-label: var(--orange-color-1000);
    --accent-yellow-primary: var(--yellow-color-500);
    --accent-yellow-secondary: var(--yellow-color-900);
    --accent-yellow-tertiary: var(--yellow-color-1000);
    --accent-yellow-label: var(--yellow-color-1000);
    --accent-green-primary: var(--green-color-500);
    --accent-green-secondary: var(--green-color-900);
    --accent-green-tertiary: var(--green-color-1000);
    --accent-green-label: var(--green-color-1000);
    --accent-blue-primary: var(--blue-color-500);
    --accent-blue-secondary: var(--blue-color-900);
    --accent-blue-tertiary: var(--blue-color-1000);
    --accent-blue-label: var(--blue-color-1000);
    --accent-purple-primary: var(--purple-color-500);
    --accent-purple-secondary: var(--purple-color-900);
    --accent-purple-tertiary: var(--purple-color-1000);
    --accent-purple-label: var(--purple-color-1000);
    --accent-grey-primary: var(--neutral-color-60);
    --accent-grey-secondary: var(--neutral-color-80);
    --accent-grey-tertiary: var(--neutral-color-100);
    --accent-grey-label: var(--neutral-color-100);
    /* overlay tokens  */
    --overlay-primary: rgba(13, 16, 17, 0.7);
    --overlay-secondary: rgba(13, 16, 17, 0.8);
  }
}
:root {
  --primary-color-100: #d5eafc;
  --primary-color-200: #abd4fa;
  --primary-color-300: #80bff7;
  --primary-color-400: #3e9cf4;
  --primary-color-500: #1480e1;
  --primary-color-600: #0c6dc7;
  --primary-color-700: #0a579f;
  --primary-color-800: #074177;
  --primary-color-900: #052c50;
  --primary-color-1000: #021628;
  --red-color-100: #ffebeb;
  --red-color-200: #ffcccc;
  --red-color-300: #ffb2b2;
  --red-color-400: #fa8989;
  --red-color-500: #f84f4f;
  --red-color-600: #ee3939;
  --red-color-700: #cc2937;
  --red-color-800: #992730;
  --red-color-900: #661414;
  --red-color-1000: #2f0404;
  --orange-color-100: #fff3eb;
  --orange-color-200: #ffe0cc;
  --orange-color-300: #ffd3b2;
  --orange-color-400: #fab784;
  --orange-color-500: #ff9433;
  --orange-color-600: #f26d0d;
  --orange-color-700: #c5591c;
  --orange-color-800: #9b4b1e;
  --orange-color-900: #663714;
  --orange-color-1000: #331500;
  --yellow-color-100: #fffaeb;
  --yellow-color-200: #fff2cc;
  --yellow-color-300: #ffecb2;
  --yellow-color-400: #fae08f;
  --yellow-color-500: #f7d53b;
  --yellow-color-600: #f5c400;
  --yellow-color-700: #d29700;
  --yellow-color-800: #b0820d;
  --yellow-color-900: #745302;
  --yellow-color-1000: #322401;
  --green-color-100: #f5feec;
  --green-color-200: #e5fccf;
  --green-color-300: #d5faaf;
  --green-color-400: #c1f091;
  --green-color-500: #96dd3c;
  --green-color-600: #75c322;
  --green-color-700: #5ba718;
  --green-color-800: #4e8b19;
  --green-color-900: #3f6614;
  --green-color-1000: #1a2b08;
  --blue-color-100: #ecf5fe;
  --blue-color-200: #cfe5fc;
  --blue-color-300: #afd6fa;
  --blue-color-400: #90caf5;
  --blue-color-500: #59aef8;
  --blue-color-600: #3b9ef7;
  --blue-color-700: #2b7bd4;
  --blue-color-800: #2a619d;
  --blue-color-900: #143f66;
  --blue-color-1000: #021b31;
  --purple-color-100: #f4ecfe;
  --purple-color-200: #e3cffc;
  --purple-color-300: #d0b0fb;
  --purple-color-400: #c198f8;
  --purple-color-500: #b06ef7;
  --purple-color-600: #944af5;
  --purple-color-700: #7231d7;
  --purple-color-800: #5828a1;
  --purple-color-900: #381466;
  --purple-color-1000: #160132;
  --neutral-color-0: #ffffff;
  --neutral-color-10: #f7f9fc;
  --neutral-color-20: #eef2f7;
  --neutral-color-30: #e3eaf2;
  --neutral-color-40: #c8d3e0;
  --neutral-color-50: #91a0b5;
  --neutral-color-60: #6c7a8b;
  --neutral-color-70: #4c5562;
  --neutral-color-80: #373d47;
  --neutral-color-90: #2d333b;
  --neutral-color-100: #24282e;
  --neutral-color-110: #191c1f;
  --neutral-color-120: #0d1011;
  --grey-color-10: #f5f6f7;
  --grey-color-20: #ebecef;
  --grey-color-30: #d7dade;
  --grey-color-40: #c2c7ce;
  --grey-color-50: #aeb5bd;
  --grey-color-60: #9298a0;
  --grey-color-70: #7b828a;
  --grey-color-80: #5c6168;
  --grey-color-90: #3e4145;
  --grey-color-100: #1f2023;
  --opacity-primary-10: rgba(25, 138, 240, 0.1);
  --opacity-primary-20: rgba(25, 138, 240, 0.2);
  --opacity-primary-30: rgba(25, 138, 240, 0.3);
  --opacity-primary-40: rgba(25, 138, 240, 0.4);
  --opacity-primary-50: rgba(25, 138, 240, 0.5);
  --opacity-primary-60: rgba(25, 138, 240, 0.6);
  --opacity-primary-70: rgba(25, 138, 240, 0.7);
  --opacity-primary-80: rgba(25, 138, 240, 0.8);
  --opacity-primary-90: rgba(25, 138, 240, 0.9);
  --opacity-red-10: rgba(242, 84, 84, 0.1);
  --opacity-red-20: rgba(242, 84, 84, 0.2);
  --opacity-red-30: rgba(242, 84, 84, 0.3);
  --opacity-red-40: rgba(242, 84, 84, 0.4);
  --opacity-red-50: rgba(242, 84, 84, 0.5);
  --opacity-red-60: rgba(242, 84, 84, 0.6);
  --opacity-red-70: rgba(242, 84, 84, 0.7);
  --opacity-red-80: rgba(242, 84, 84, 0.8);
  --opacity-red-90: rgba(242, 84, 84, 0.9);
  --opacity-neutral-10: rgba(145, 160, 181, 0.1);
  --opacity-neutral-20: rgba(145, 160, 181, 0.2);
  --opacity-neutral-30: rgba(145, 160, 181, 0.3);
  --opacity-neutral-40: rgba(145, 160, 181, 0.4);
  --opacity-neutral-50: rgba(145, 160, 181, 0.5);
  /* primary tokens */
  --primary-default: var(--primary-color-600);
  --primary-hover: var(--primary-color-700);
  --primary-active: var(--primary-color-800);
  --primary-disabled: var(--neutral-color-40);
  /* background */
  --background-primary: var(--neutral-color-0);
  --background-secondary: var(--neutral-color-0);
  --background-tertiary: var(--neutral-color-10);
  --background-quaternary: var(--neutral-color-10);
  --background-quaternary: var(--neutral-color-30);
  --background-hover: var(--opacity-neutral-10);
  --background-active: var(--opacity-primary-10);
  --background-disabled: var(--neutral-color-10);
  --background-tinted: var(--blue-color-100);
  --background-danger: var(--red-color-100);
  --background-danger-active: var(--opacity-red-10);
  /* border tokens  */
  --border-primary: var(--neutral-color-50);
  --border-secondary: var(--neutral-color-40);
  --border-tertiary: var(--neutral-color-30);
  --border-quaternary: var(--neutral-color-20);
  --border-hover: var(--primary-color-500);
  --border-active: var(--primary-color-500);
  --border-danger: var(--red-color-600);
  --border-disabled: var(--neutral-color-40);
  /* text tokens  */
  --text-primary: var(--grey-color-100);
  --text-secondary: var(--grey-color-70);
  --text-tertiary: var(--grey-color-60);
  --text-disabled: var(--neutral-color-40);
  --text-danger: var(--red-color-600);
  --text-on-color: var(--neutral-color-0);
  --text-on-color-disabled: var(--neutral-color-0);
  --text-link: var(--primary-color-500);
  /* icon tokens  */
  --icon-primary: var(--neutral-color-60);
  --icon-emphasis: var(--neutral-color-110);
  --icon-accent: var(--primary-color-500);
  --icon-disabled: var(--neutral-color-40);
  --icon-on-color: var(--neutral-color-0);
  --icon-color-disabled: var(--neutral-color-0);
  /* support tokens  */
  --support-danger-default: var(--red-color-600);
  --support-danger-hover: var(--red-color-700);
  --support-danger-active: var(--red-color-800);
  --support-approve-default: var(--green-color-600);
  --support-approve-hover: var(--green-color-700);
  --support-approve-active: var(--green-color-800);
  /* status tokens  */
  --status-success: var(--green-color-600);
  --status-warning: var(--yellow-color-600);
  --status-information: var(--blue-color-600);
  --status-danger: var(--red-color-600);
  --status-disabled: var(--neutral-color-50);
  /* Accent Tokens  */
  --accent-red-primary: var(--red-color-600);
  --accent-red-secondary: var(--red-color-300);
  --accent-red-tertiary: var(--red-color-100);
  --accent-red-label: var(--neutral-color-0);
  --accent-orange-primary: var(--orange-color-600);
  --accent-orange-secondary: var(--orange-color-300);
  --accent-orange-tertiary: var(--orange-color-100);
  --accent-orange-label: var(--neutral-color-0);
  --accent-yellow-primary: var(--yellow-color-600);
  --accent-yellow-secondary: var(--yellow-color-300);
  --accent-yellow-tertiary: var(--yellow-color-100);
  --accent-yellow-label: var(--neutral-color-0);
  --accent-green-primary: var(--green-color-600);
  --accent-green-secondary: var(--green-color-300);
  --accent-green-tertiary: var(--green-color-100);
  --accent-green-label: var(--neutral-color-0);
  --accent-blue-primary: var(--blue-color-600);
  --accent-blue-secondary: var(--blue-color-300);
  --accent-blue-tertiary: var(--blue-color-100);
  --accent-blue-label: var(--neutral-color-0);
  --accent-purple-primary: var(--purple-color-600);
  --accent-purple-secondary: var(--purple-color-300);
  --accent-purple-tertiary: var(--purple-color-100);
  --accent-purple-label: var(--neutral-color-0);
  --accent-grey-primary: var(--neutral-color-50);
  --accent-grey-secondary: var(--neutral-color-30);
  --accent-grey-tertiary: var(--neutral-color-10);
  --accent-grey-label: var(--neutral-color-0);
  /* overlay tokens  */
  --overlay-primary: rgba(36, 40, 46, 0.1);
  --overlay-secondary: rgba(36, 40, 46, 0.3);
}

@media (prefers-color-scheme: dark) {
  :root {
    /* primary tokens */
    --primary-default: var(--primary-color-500);
    --primary-hover: var(--primary-color-600);
    --primary-active: var(--primary-color-700);
    --primary-disabled: var(--neutral-color-80);
    /* background */
    --background-primary: var(--neutral-color-120);
    --background-secondary: var(--neutral-color-110);
    --background-tertiary: var(--neutral-color-110);
    --background-quaternary: var(--neutral-color-100);
    --background-quaternary: var(--neutral-color-80);
    --background-hover: var(--opacity-neutral-10);
    --background-active: var(--opacity-primary-20);
    --background-disabled: var(--neutral-color-110);
    --background-tinted: var(--blue-color-1000);
    --background-danger: var(--red-color-1000);
    --background-danger-active: var(--opacity-red-20);
    /* border tokens  */
    --border-primary: var(--neutral-color-60);
    --border-secondary: var(--neutral-color-80);
    --border-tertiary: var(--neutral-color-100);
    --border-quaternary: var(--neutral-color-110);
    --border-hover: var(--primary-color-400);
    --border-active: var(--primary-color-400);
    --border-danger: var(--red-color-500);
    --border-disabled: var(--neutral-color-80);
    /* text tokens  */
    --text-primary: var(--grey-color-20);
    --text-secondary: var(--grey-color-60);
    --text-tertiary: var(--grey-color-80);
    --text-disabled: var(--neutral-color-80);
    --text-danger: var(--red-color-500);
    --text-on-color: var(--neutral-color-0);
    --text-on-color-disabled: var(--neutral-color-120);
    --text-link: var(--primary-color-400);
    /* icon tokens  */
    --icon-primary: var(--grey-color-50);
    --icon-emphasis: var(--neutral-color-10);
    --icon-accent: var(--primary-color-400);
    --icon-disabled: var(--neutral-color-80);
    --icon-on-color: var(--neutral-color-0);
    --icon-color-disabled: var(--neutral-color-80);
    /* support tokens  */
    --support-danger-default: var(--red-color-500);
    --support-danger-hover: var(--red-color-600);
    --support-danger-active: var(--red-color-700);
    --support-approve-default: var(--green-color-600);
    --support-approve-hover: var(--green-color-700);
    --support-approve-active: var(--green-color-800);
    /* status tokens  */
    --status-success: var(--green-color-500);
    --status-warning: var(--yellow-color-500);
    --status-information: var(--blue-color-500);
    --status-danger: var(--red-color-500);
    --status-disabled: var(--neutral-color-50);
    /* Accent Tokens  */
    --accent-red-primary: var(--red-color-500);
    --accent-red-secondary: var(--red-color-900);
    --accent-red-tertiary: var(--red-color-1000);
    --accent-red-label: var(--red-color-1000);
    --accent-orange-primary: var(--orange-color-500);
    --accent-orange-secondary: var(--orange-color-900);
    --accent-orange-tertiary: var(--orange-color-1000);
    --accent-orange-label: var(--orange-color-1000);
    --accent-yellow-primary: var(--yellow-color-500);
    --accent-yellow-secondary: var(--yellow-color-900);
    --accent-yellow-tertiary: var(--yellow-color-1000);
    --accent-yellow-label: var(--yellow-color-1000);
    --accent-green-primary: var(--green-color-500);
    --accent-green-secondary: var(--green-color-900);
    --accent-green-tertiary: var(--green-color-1000);
    --accent-green-label: var(--green-color-1000);
    --accent-blue-primary: var(--blue-color-500);
    --accent-blue-secondary: var(--blue-color-900);
    --accent-blue-tertiary: var(--blue-color-1000);
    --accent-blue-label: var(--blue-color-1000);
    --accent-purple-primary: var(--purple-color-500);
    --accent-purple-secondary: var(--purple-color-900);
    --accent-purple-tertiary: var(--purple-color-1000);
    --accent-purple-label: var(--purple-color-1000);
    --accent-grey-primary: var(--neutral-color-60);
    --accent-grey-secondary: var(--neutral-color-80);
    --accent-grey-tertiary: var(--neutral-color-100);
    --accent-grey-label: var(--neutral-color-100);
    /* overlay tokens  */
    --overlay-primary: rgba(13, 16, 17, 0.7);
    --overlay-secondary: rgba(13, 16, 17, 0.8);
  }
}
@font-face {
  font-family: poppins_bold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: poppins_semibold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: poppins_medium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: poppins_regular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
* {
  padding: 0px;
  margin: 0px;
  box-sizing: border-box !important;
  line-height: unset !important;
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: grayscale;
}

html,
body {
  font-display: swap;
  font-family: "Poppins";
  max-width: 100vw;
}

ul,
li {
  list-style: none;
  list-style-type: none;
}

img {
  vertical-align: middle;
}

button {
  cursor: pointer;
  background: none;
  outline: none;
  border: none;
}

a,
p,
span,
li,
div,
button,
input,
textarea {
  font-family: poppins_regular !important;
}

input {
  border: none;
  background: none;
  color: var(--text-primary);
}

textarea {
  color: var(--text-primary);
}

/* Hide the number input arrow buttons */
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  /* Optional: Define styles for appearance and cursor */ /* Firefox */
  appearance: textfield; /* Other browsers */
  cursor: text;
}

textarea {
  background: none;
}

a {
  text-decoration: none !important;
}

p {
  margin: 0;
  padding: 0;
}

.StatusMenu_Wrapper__FNkQJ {
  margin: auto;
}

.StatusMenu_pagePopUp__7o0Sl {
  position: relative;
  width: 100%;
  height: 100vh;
  z-index: 500;
}

.StatusMenu_overlay__VTkA5 {
  width: 100vw;
  height: 100vh;
  flex-shrink: 0;
  background: var(--overlay-primary, rgba(36, 40, 46, 0.1));
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  overflow: hidden;
}

.StatusMenu_light-mode__x5xCS {
  --default-primary: #0c6dc7;
  --primary-default: #0c6dc7;
  --primary-hover: #0a579f;
  --primary-active: #074177;
  --primary-disabled: #c8d3e0;
  --primary-rpm-default: #5ba718;
  --primary-rpm-hover: #4e8b19;
  --primary-rpm-active: #3f6614;
  --primary-rpm-disabled: #c8d3e0;
  --background-primary: #ffffff;
  --background-secondary: #ffffff;
  --background-tertiary: #f7f9fc;
  --background-quaternary: #f7f9fc;
  --background-emphasis: #e3eaf2;
  --background-mixed: #e3eaf2;
  --background-hover: rgba(145, 160, 181, 0.0980392157);
  --background-active: rgba(25, 138, 240, 0.0980392157);
  --background-rpm-active: rgba(117, 195, 34, 0.0980392157);
  --background-disabled: #f7f9fc;
  --background-tinted: #ecf5fe;
  --background-danger: #ffebeb;
  --background-danger-active: rgba(242, 84, 84, 0.0980392157);
  --background-emphasis-strong: #0d1011;
  --border-primary: #91a0b5;
  --border-secondary: #c8d3e0;
  --border-tertiary: #e3eaf2;
  --border-quaternary: #eef2f7;
  --border-hover: #1480e1;
  --border-active: #1480e1;
  --border-danger: #ee3939;
  --border-disabled: #c8d3e0;
  --text-primary: #1f2023;
  --text-secondary: #7b828a;
  --text-tertiary: #9298a0;
  --text-disabled: #c8d3e0;
  --text-danger: #ee3939;
  --text-on-color: #ffffff;
  --text-on-color-disabled: #ffffff;
  --text-link: #1480e1;
  --icon-primary: #6c7a8b;
  --icon-emphasis: #191c1f;
  --icon-accent: #1480e1;
  --icon-disabled: #c8d3e0;
  --icon-on-color: #ffffff;
  --icon-color-disabled: #ffffff;
  --support-danger: #ee3939;
  --support-danger-default: #ee3939;
  --support-danger-hover: #cc2937;
  --support-danger-active: #992730;
  --support-approve-default: #75c322;
  --support-approve-hover: #5ba718;
  --support-approve-active: #4e8b19;
  --status-success: #75c322;
  --status-warning: #f5c400;
  --status-information: #3b9ef7;
  --status-danger: #ee3939;
  --status-disabled: #91a0b5;
  --accent-red-primary: #ee3939;
  --accent-red-secondary: #ffb2b2;
  --accent-red-tertiary: #ffebeb;
  --accent-red-label: #ffffff;
  --accent-orange-primary: #f26d0d;
  --accent-orange-secondary: #ffd3b2;
  --accent-orange-tertiary: #fff3eb;
  --accent-orange-label: #ffffff;
  --accent-yellow-primary: #f5c400;
  --accent-yellow-secondary: #ffecb2;
  --accent-yellow-tertiary: #fffaeb;
  --accent-yellow-label: #ffffff;
  --accent-green-primary: #75c322;
  --accent-green-secondary: #5d8a2d;
  --accent-green-tertiary: #f5feec;
  --accent-green-label: #ffffff;
  --accent-blue-primary: #3b9ef7;
  --accent-blue-secondary: #afd6fa;
  --accent-blue-tertiary: #ecf5fe;
  --accent-blue-label: #ffffff;
  --accent-purple-primary: #944af5;
  --accent-purple-secondary: #d0b0fb;
  --accent-purple-tertiary: #f4ecfe;
  --accent-purple-label: #ffffff;
  --accent-grey-primary: #91a0b5;
  --accent-grey-secondary: #e3eaf2;
  --accent-grey-tertiary: #f7f9fc;
  --accent-grey-label: #ffffff;
  --overlay-primary: rgba(36, 40, 46, 0.0980392157);
  --overlay-secondary: rgba(36, 40, 46, 0.2980392157);
  --hover-primary: #f4f5f8;
  --scroll-primary: #949ba7;
  --box-shadow-primary: #e3eaf2;
  --card-green-hover: #75c322;
  --card-green: #f5feec;
  --card-light-green: #e3eaf2;
  --card-white: #e3eaf2;
  --card-gray: #e3eaf2;
}

.StatusMenu_dark-mode__GEBxk {
  --default-primary: #1480e1;
  --primary-default: #1480e1;
  --primary-hover: #0c6dc7;
  --primary-active: #0a579f;
  --primary-disabled: #373d47;
  --primary-rpm-default: #75c322;
  --primary-rpm-hover: #5ba718;
  --primary-rpm-active: #4e8b19;
  --primary-rpm-disabled: #373d47;
  --background-primary: #0d1011;
  --background-secondary: #191c1f;
  --background-tertiary: #191c1f;
  --background-quaternary: #24282e;
  --background-emphasis: #373d47;
  --background-mixed: #24282e;
  --background-hover: rgba(145, 160, 181, 0.0980392157);
  --background-active: rgba(25, 138, 240, 0.2);
  --background-rpm-active: rgba(117, 195, 34, 0.2);
  --background-disabled: #191c1f;
  --background-tinted: #021b31;
  --background-danger: #2f0404;
  --background-danger-active: rgba(242, 84, 84, 0.2);
  --background-emphasis-strong: #f7f9fc;
  --border-primary: #6c7a8b;
  --border-secondary: #373d47;
  --border-tertiary: #24282e;
  --border-quaternary: #191c1f;
  --border-hover: #3e9cf4;
  --border-active: #3e9cf4;
  --border-danger: #f84f4f;
  --border-disabled: #373d47;
  --text-primary: #ebecef;
  --text-secondary: #9298a0;
  --text-tertiary: #5c6168;
  --text-disabled: #373d47;
  --text-danger: #f84f4f;
  --text-on-color: #ffffff;
  --text-on-color-disabled: #0d1011;
  --text-link: #3e9cf4;
  --icon-primary: #aeb5bd;
  --icon-emphasis: #f7f9fc;
  --icon-accent: #3e9cf4;
  --icon-disabled: #373d47;
  --icon-on-color: #ffffff;
  --icon-color-disabled: #373d47;
  --support-danger: #f84f4f;
  --support-danger-default: #f84f4f;
  --support-danger-hover: #ee3939;
  --support-danger-active: #cc2937;
  --support-approve-default: #75c322;
  --support-approve-hover: #5ba718;
  --support-approve-active: #4e8b19;
  --status-success: #96dd3c;
  --status-warning: #f7d53b;
  --status-information: #59aef8;
  --status-danger: #f84f4f;
  --status-disabled: #91a0b5;
  --accent-red-primary: #f84f4f;
  --accent-red-secondary: #661414;
  --accent-red-tertiary: #2f0404;
  --accent-red-label: #2f0404;
  --accent-orange-primary: #ff9433;
  --accent-orange-secondary: #663714;
  --accent-orange-tertiary: #331500;
  --accent-orange-label: #331500;
  --accent-yellow-primary: #f7d53b;
  --accent-yellow-secondary: #745302;
  --accent-yellow-tertiary: #322401;
  --accent-yellow-label: #322401;
  --accent-green-primary: #96dd3c;
  --accent-green-secondary: #3f6614;
  --accent-green-tertiary: #1a2b08;
  --accent-green-label: #1a2b08;
  --accent-blue-primary: #59aef8;
  --accent-blue-secondary: #2a619d;
  --accent-blue-tertiary: #021b31;
  --accent-blue-label: #021b31;
  --accent-purple-primary: #b06ef7;
  --accent-purple-secondary: #381466;
  --accent-purple-tertiary: #160132;
  --accent-purple-label: #160132;
  --accent-grey-primary: #6c7a8b;
  --accent-grey-secondary: #373d47;
  --accent-grey-tertiary: #24282e;
  --accent-grey-label: #24282e;
  --overlay-primary: rgba(13, 16, 17, 0.6980392157);
  --overlay-secondary: rgba(13, 16, 17, 0.8);
  --hover-primary: #25292e;
  --scroll-primary: #2a2c30;
  --box-shadow-primary: #191c1f;
  --card-green-hover: #3f6614;
  --card-green: #f5feec;
  --card-light-green: #191c1f;
  --card-white: #191c1f;
  --card-gray: #191c1f;
}

.StatusMenu_profileMenu__Tp4js {
  width: 100%;
  height: 100vh;
  flex-shrink: 0;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1001;
  display: flex;
  justify-content: center;
  align-items: center;
}

.StatusMenu_profileBox__D\\+OEC {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1001;
  width: 460px;
  padding: 15px;
  border-radius: 8px;
  /* ◻️ Light/action_shadow */
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.05);
  background: var(--background-secondary);
  animation: StatusMenu_slideIn__sm8yz 0.5s ease forwards;
}

.StatusMenu_headline__X9ppn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--text-secondary);
}

.StatusMenu_heading__IzZWX {
  padding: 10px;
  color: #9298a0;
}

.StatusMenu_status__DfEQ8 {
  margin-bottom: 15px;
}
.StatusMenu_status_type__vQ01e {
  border-radius: 8px;
  display: flex;
  height: 40px;
  width: 100%;
  padding: 10px 35px 10px 12px;
  gap: 10px;
  border: 1px solid transparent;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.StatusMenu_status_type__vQ01e span {
  display: flex;
  gap: 10px;
  align-items: center;
  color: var(--text-primary);
}
.StatusMenu_status_type__vQ01e:hover {
  border-radius: 8px;
  border: 1px solid var(--border-tertiary);
  background: var(--opacity-neutral-10);
}
.StatusMenu_status_type__vQ01e:hover .StatusMenu_status_type_active__w2i4D {
  font-weight: 500;
}

.StatusMenu_clearStatus__pE5NK {
  border-radius: 8px;
  border: 1px solid var(--border-secondary);
  display: inline-flex;
  padding: 7px 10px;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  color: var(--text-secondary) !important;
  font-size: 0.88em;
  cursor: pointer;
}

@media screen and (max-width: 500px) {
  .StatusMenu_profileBox__D\\+OEC {
    width: calc(100% - 40px);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Profile/StatusMenu/StatusMenu.module.scss","webpack://./src/sass/abstracts/_animation.scss","webpack://./src/sass/abstracts/_variables.scss","webpack://./src/sass/base/_basic.scss","webpack://./src/sass/themes/_themes.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACC;IACC,2BAAA;EDEA;ECAD;IACC,wDAAA;IACA,wBAAA;EDEA;AACF;ACCA;EACC;IACC,iCAAA;IACA,UAAA;EDCA;ECCD;IACC,gCAAA;IACA,UAAA;EDCA;AACF;AEWA;EACC,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EAEA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,yBAAA;EAEA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,4BAAA;EAEA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,4BAAA;EAEA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,2BAAA;EAEA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;EAEA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,4BAAA;EAEA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,yBAAA;EAEA,6CAAA;EACA,6CAAA;EACA,6CAAA;EACA,6CAAA;EACA,6CAAA;EACA,6CAAA;EACA,6CAAA;EACA,6CAAA;EACA,6CAAA;EAEA,wCAAA;EACA,wCAAA;EACA,wCAAA;EACA,wCAAA;EACA,wCAAA;EACA,wCAAA;EACA,wCAAA;EACA,wCAAA;EACA,wCAAA;EAEA,8CAAA;EACA,8CAAA;EACA,8CAAA;EACA,8CAAA;EACA,8CAAA;EAEA,mBAAA;EACA,2CAAA;EACA,yCAAA;EACA,0CAAA;EACA,2CAAA;EAEA,eAAA;EACA,4CAAA;EACA,8CAAA;EACA,8CAAA;EACA,gDAAA;EACA,gDAAA;EACA,6CAAA;EACA,8CAAA;EACA,8CAAA;EACA,0CAAA;EACA,yCAAA;EACA,iDAAA;EAEA,mBAAA;EACA,yCAAA;EACA,2CAAA;EACA,0CAAA;EACA,4CAAA;EACA,wCAAA;EACA,yCAAA;EACA,qCAAA;EACA,0CAAA;EAEA,iBAAA;EACA,qCAAA;EACA,sCAAA;EACA,qCAAA;EACA,wCAAA;EACA,mCAAA;EACA,uCAAA;EACA,gDAAA;EACA,qCAAA;EAEA,iBAAA;EACA,uCAAA;EACA,yCAAA;EACA,uCAAA;EACA,wCAAA;EACA,uCAAA;EACA,6CAAA;EAEA,oBAAA;EACA,8CAAA;EACA,4CAAA;EACA,6CAAA;EACA,iDAAA;EACA,+CAAA;EACA,gDAAA;EAEA,mBAAA;EACA,wCAAA;EACA,yCAAA;EACA,2CAAA;EACA,qCAAA;EACA,0CAAA;EAEA,mBAAA;EACA,0CAAA;EACA,4CAAA;EACA,2CAAA;EACA,0CAAA;EACA,gDAAA;EACA,kDAAA;EACA,iDAAA;EACA,6CAAA;EACA,gDAAA;EACA,kDAAA;EACA,iDAAA;EACA,6CAAA;EACA,8CAAA;EACA,gDAAA;EACA,+CAAA;EACA,4CAAA;EACA,4CAAA;EACA,8CAAA;EACA,6CAAA;EACA,2CAAA;EACA,gDAAA;EACA,kDAAA;EACA,iDAAA;EACA,6CAAA;EACA,8CAAA;EACA,gDAAA;EACA,+CAAA;EACA,2CAAA;EAEA,oBAAA;EACA,wCAAA;EACA,0CAAA;AF7BD;;AEgCA;EACC;IACC,mBAAA;IACA,2CAAA;IACA,yCAAA;IACA,0CAAA;IACA,2CAAA;IAEA,eAAA;IACA,8CAAA;IACA,gDAAA;IACA,+CAAA;IACA,iDAAA;IACA,gDAAA;IACA,6CAAA;IACA,8CAAA;IACA,+CAAA;IACA,2CAAA;IACA,0CAAA;IACA,iDAAA;IAEA,mBAAA;IACA,yCAAA;IACA,2CAAA;IACA,2CAAA;IACA,6CAAA;IACA,wCAAA;IACA,yCAAA;IACA,qCAAA;IACA,0CAAA;IAEA,iBAAA;IACA,oCAAA;IACA,sCAAA;IACA,qCAAA;IACA,wCAAA;IACA,mCAAA;IACA,uCAAA;IACA,kDAAA;IACA,qCAAA;IAEA,iBAAA;IACA,oCAAA;IACA,wCAAA;IACA,uCAAA;IACA,wCAAA;IACA,uCAAA;IACA,8CAAA;IAEA,oBAAA;IACA,8CAAA;IACA,4CAAA;IACA,6CAAA;IACA,iDAAA;IACA,+CAAA;IACA,gDAAA;IAEA,mBAAA;IACA,wCAAA;IACA,yCAAA;IACA,2CAAA;IACA,qCAAA;IACA,0CAAA;IAEA,mBAAA;IACA,0CAAA;IACA,4CAAA;IACA,4CAAA;IACA,yCAAA;IACA,gDAAA;IACA,kDAAA;IACA,kDAAA;IACA,+CAAA;IACA,gDAAA;IACA,kDAAA;IACA,kDAAA;IACA,+CAAA;IACA,8CAAA;IACA,gDAAA;IACA,gDAAA;IACA,6CAAA;IACA,4CAAA;IACA,8CAAA;IACA,8CAAA;IACA,2CAAA;IACA,gDAAA;IACA,kDAAA;IACA,kDAAA;IACA,+CAAA;IACA,8CAAA;IACA,gDAAA;IACA,gDAAA;IACA,6CAAA;IAEA,oBAAA;IACA,wCAAA;IACA,0CAAA;EFrCA;AACF;AE9RA;EACC,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EAEA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,yBAAA;EAEA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,4BAAA;EAEA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,4BAAA;EAEA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,2BAAA;EAEA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;EAEA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,4BAAA;EAEA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,wBAAA;EACA,yBAAA;EAEA,6CAAA;EACA,6CAAA;EACA,6CAAA;EACA,6CAAA;EACA,6CAAA;EACA,6CAAA;EACA,6CAAA;EACA,6CAAA;EACA,6CAAA;EAEA,wCAAA;EACA,wCAAA;EACA,wCAAA;EACA,wCAAA;EACA,wCAAA;EACA,wCAAA;EACA,wCAAA;EACA,wCAAA;EACA,wCAAA;EAEA,8CAAA;EACA,8CAAA;EACA,8CAAA;EACA,8CAAA;EACA,8CAAA;EAEA,mBAAA;EACA,2CAAA;EACA,yCAAA;EACA,0CAAA;EACA,2CAAA;EAEA,eAAA;EACA,4CAAA;EACA,8CAAA;EACA,8CAAA;EACA,gDAAA;EACA,gDAAA;EACA,6CAAA;EACA,8CAAA;EACA,8CAAA;EACA,0CAAA;EACA,yCAAA;EACA,iDAAA;EAEA,mBAAA;EACA,yCAAA;EACA,2CAAA;EACA,0CAAA;EACA,4CAAA;EACA,wCAAA;EACA,yCAAA;EACA,qCAAA;EACA,0CAAA;EAEA,iBAAA;EACA,qCAAA;EACA,sCAAA;EACA,qCAAA;EACA,wCAAA;EACA,mCAAA;EACA,uCAAA;EACA,gDAAA;EACA,qCAAA;EAEA,iBAAA;EACA,uCAAA;EACA,yCAAA;EACA,uCAAA;EACA,wCAAA;EACA,uCAAA;EACA,6CAAA;EAEA,oBAAA;EACA,8CAAA;EACA,4CAAA;EACA,6CAAA;EACA,iDAAA;EACA,+CAAA;EACA,gDAAA;EAEA,mBAAA;EACA,wCAAA;EACA,yCAAA;EACA,2CAAA;EACA,qCAAA;EACA,0CAAA;EAEA,mBAAA;EACA,0CAAA;EACA,4CAAA;EACA,2CAAA;EACA,0CAAA;EACA,gDAAA;EACA,kDAAA;EACA,iDAAA;EACA,6CAAA;EACA,gDAAA;EACA,kDAAA;EACA,iDAAA;EACA,6CAAA;EACA,8CAAA;EACA,gDAAA;EACA,+CAAA;EACA,4CAAA;EACA,4CAAA;EACA,8CAAA;EACA,6CAAA;EACA,2CAAA;EACA,gDAAA;EACA,kDAAA;EACA,iDAAA;EACA,6CAAA;EACA,8CAAA;EACA,gDAAA;EACA,+CAAA;EACA,2CAAA;EAEA,oBAAA;EACA,wCAAA;EACA,0CAAA;AF4QD;;AEzQA;EACC;IACC,mBAAA;IACA,2CAAA;IACA,yCAAA;IACA,0CAAA;IACA,2CAAA;IAEA,eAAA;IACA,8CAAA;IACA,gDAAA;IACA,+CAAA;IACA,iDAAA;IACA,gDAAA;IACA,6CAAA;IACA,8CAAA;IACA,+CAAA;IACA,2CAAA;IACA,0CAAA;IACA,iDAAA;IAEA,mBAAA;IACA,yCAAA;IACA,2CAAA;IACA,2CAAA;IACA,6CAAA;IACA,wCAAA;IACA,yCAAA;IACA,qCAAA;IACA,0CAAA;IAEA,iBAAA;IACA,oCAAA;IACA,sCAAA;IACA,qCAAA;IACA,wCAAA;IACA,mCAAA;IACA,uCAAA;IACA,kDAAA;IACA,qCAAA;IAEA,iBAAA;IACA,oCAAA;IACA,wCAAA;IACA,uCAAA;IACA,wCAAA;IACA,uCAAA;IACA,8CAAA;IAEA,oBAAA;IACA,8CAAA;IACA,4CAAA;IACA,6CAAA;IACA,iDAAA;IACA,+CAAA;IACA,gDAAA;IAEA,mBAAA;IACA,wCAAA;IACA,yCAAA;IACA,2CAAA;IACA,qCAAA;IACA,0CAAA;IAEA,mBAAA;IACA,0CAAA;IACA,4CAAA;IACA,4CAAA;IACA,yCAAA;IACA,gDAAA;IACA,kDAAA;IACA,kDAAA;IACA,+CAAA;IACA,gDAAA;IACA,kDAAA;IACA,kDAAA;IACA,+CAAA;IACA,8CAAA;IACA,gDAAA;IACA,gDAAA;IACA,6CAAA;IACA,4CAAA;IACA,8CAAA;IACA,8CAAA;IACA,2CAAA;IACA,gDAAA;IACA,kDAAA;IACA,kDAAA;IACA,+CAAA;IACA,8CAAA;IACA,gDAAA;IACA,gDAAA;IACA,6CAAA;IAEA,oBAAA;IACA,wCAAA;IACA,0CAAA;EFoQA;AACF;AGnmBA;EACC,yBAAA;EACA,4CAAA;AHqmBD;AGlmBA;EACC,6BAAA;EACA,4CAAA;AHomBD;AGjmBA;EACC,2BAAA;EACA,4CAAA;AHmmBD;AGhmBA;EACC,4BAAA;EACA,4CAAA;AHkmBD;AG/lBA;EACC,YAAA;EACA,WAAA;EACA,iCAAA;EACA,6BAAA;EACA,4BAAA;EACA,kCAAA;AHimBD;;AG9lBA;;EAEC,kBAAA;EACA,sBAAA;EACA,gBAAA;AHimBD;;AG9lBA;;EAEC,gBAAA;EACA,qBAAA;AHimBD;;AG9lBA;EACC,sBAAA;AHimBD;;AG9lBA;EACC,eAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;AHimBD;;AG9lBA;;;;;;;;EAQC,uCAAA;AHimBD;;AG9lBA;EACC,YAAA;EACA,gBAAA;EACA,0BAAA;AHimBD;;AG9lBA;EACC,0BAAA;AHimBD;;AG9lBA,wCAAA;AACA;;EAEC,wBAAA;EACA,SAAA;AHimBD;;AG9lBA;EACC,sDAAA,EACA,YAAA;EACA,qBAAA,EAAA,mBAAA;EACA,YAAA;AHimBD;;AG9lBA;EACC,gBAAA;AHimBD;;AG9lBA;EACC,gCAAA;AHimBD;;AG9lBA;EACC,SAAA;EACA,UAAA;AHimBD;;AG9lBA;EACC,YAAA;AHimBD;;AG9lBA;EACC,kBAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;AHimBD;;AG9lBA;EACC,YAAA;EACA,aAAA;EACA,cAAA;EAEA,yDAAA;EAEA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EAEA,gBAAA;AH8lBD;;AI1PA;EANI,0BAAA;EAAA,0BAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,2BAAA;EAAA,8BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,+BAAA;EAAA,6BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,gCAAA;EAAA,8BAAA;EAAA,2BAAA;EAAA,qDAAA;EAAA,qDAAA;EAAA,yDAAA;EAAA,8BAAA;EAAA,4BAAA;EAAA,4BAAA;EAAA,2DAAA;EAAA,qCAAA;EAAA,yBAAA;EAAA,2BAAA;EAAA,0BAAA;EAAA,4BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,0BAAA;EAAA,uBAAA;EAAA,yBAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,sBAAA;EAAA,wBAAA;EAAA,iCAAA;EAAA,oBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,sBAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,8BAAA;EAAA,yBAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,gCAAA;EAAA,kCAAA;EAAA,gCAAA;EAAA,iCAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,6BAAA;EAAA,wBAAA;EAAA,0BAAA;EAAA,6BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,2BAAA;EAAA,gCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,gCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,+BAAA;EAAA,iCAAA;EAAA,gCAAA;EAAA,6BAAA;EAAA,8BAAA;EAAA,gCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,gCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,gCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,iDAAA;EAAA,mDAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,qBAAA;EAAA,oBAAA;AJkWJ;;AIxVA;EAVI,0BAAA;EAAA,0BAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,2BAAA;EAAA,8BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,+BAAA;EAAA,6BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,gCAAA;EAAA,8BAAA;EAAA,2BAAA;EAAA,qDAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,8BAAA;EAAA,4BAAA;EAAA,4BAAA;EAAA,kDAAA;EAAA,qCAAA;EAAA,yBAAA;EAAA,2BAAA;EAAA,0BAAA;EAAA,4BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,0BAAA;EAAA,uBAAA;EAAA,yBAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,sBAAA;EAAA,wBAAA;EAAA,iCAAA;EAAA,oBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,sBAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,8BAAA;EAAA,yBAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,gCAAA;EAAA,kCAAA;EAAA,gCAAA;EAAA,iCAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,6BAAA;EAAA,wBAAA;EAAA,0BAAA;EAAA,6BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,2BAAA;EAAA,gCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,gCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,+BAAA;EAAA,iCAAA;EAAA,gCAAA;EAAA,6BAAA;EAAA,8BAAA;EAAA,gCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,gCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,gCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,iDAAA;EAAA,0CAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,qBAAA;EAAA,oBAAA;AJocJ;;AA95BA;EACC,WAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAi6BD;;AA95BA;EACC,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,2BAAA;EACA,gDAAA;EACA,uCAAA;EAEA,uDAAA;AAg6BD;;AA75BA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,4BAAA;AAg6BD;;AA75BA;EACC,aAAA;EACA,cAAA;AAg6BD;;AA75BA;EACC,mBAAA;AAg6BD;AA95BC;EACC,kBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,4BAAA;EACA,SAAA;EAEA,6BAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;AA+5BF;AA75BE;EACC,aAAA;EACA,SAAA;EACA,mBAAA;EACA,0BAAA;AA+5BH;AA55BE;EACC,kBAAA;EACA,wCAAA;EACA,qCAAA;AA85BH;AA55BG;EACC,gBAAA;AA85BJ;;AAx5BA;EACC,kBAAA;EACA,yCAAA;EACA,oBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uCAAA;EACA,iBAAA;EACA,eAAA;AA25BD;;AAx5BA;EACC;IACC,wBAAA;EA25BA;AACF","sourcesContent":["@import \"../../../sass/index.scss\";\n\n.profileMenu {\n\twidth: 100%;\n\theight: 100vh;\n\tflex-shrink: 0;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tz-index: 1001;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.profileBox {\n\tposition: fixed;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\tz-index: 1001;\n\twidth: 460px;\n\tpadding: 15px;\n\tborder-radius: 8px;\n\t/* ◻️ Light/action_shadow */\n\tbox-shadow: 0px 0px 16px 0px map-get($color, dark-box-shadow);\n\tbackground: var(--background-secondary);\n\n\tanimation: slideIn 0.5s ease forwards;\n}\n\n.headline {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tcolor: var(--text-secondary);\n}\n\n.heading {\n\tpadding: 10px;\n\tcolor: map-get($color, grey-color-60);\n}\n\n.status {\n\tmargin-bottom: 15px;\n\n\t&_type {\n\t\tborder-radius: 8px;\n\t\tdisplay: flex;\n\t\theight: 40px;\n\t\twidth: 100%;\n\t\tpadding: 10px 35px 10px 12px;\n\t\tgap: 10px;\n\n\t\tborder: 1px solid transparent;\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tcursor: pointer;\n\n\t\t& span {\n\t\t\tdisplay: flex;\n\t\t\tgap: 10px;\n\t\t\talign-items: center;\n\t\t\tcolor: var(--text-primary);\n\t\t}\n\n\t\t&:hover {\n\t\t\tborder-radius: 8px;\n\t\t\tborder: 1px solid var(--border-tertiary);\n\t\t\tbackground: var(--opacity-neutral-10);\n\n\t\t\t& .status_type_active {\n\t\t\t\tfont-weight: 500;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.clearStatus {\n\tborder-radius: 8px;\n\tborder: 1px solid var(--border-secondary);\n\tdisplay: inline-flex;\n\tpadding: 7px 10px;\n\tjustify-content: center;\n\talign-items: center;\n\tmargin-top: 10px;\n\tcolor: var(--text-secondary) !important;\n\tfont-size: 0.88em;\n\tcursor: pointer;\n}\n\n@media screen and (max-width: 500px) {\n\t.profileBox {\n\t\twidth: calc(100% - 40px);\n\t}\n}\n","@keyframes slideFromRight {\n\tfrom {\n\t\ttransform: translateX(100%);\n\t}\n\tto {\n\t\t/* Move to the final position when animation completes */\n\t\ttransform: translateX(0);\n\t}\n}\n\n@keyframes slideIn {\n\tfrom {\n\t\ttransform: translate(-50%, -200%);\n\t\topacity: 0;\n\t}\n\tto {\n\t\ttransform: translate(-50%, -50%);\n\t\topacity: 1;\n\t}\n}\n","$color: (\n\ttext-secondary: #7b828a,\n\ttext-secondary-2: #5c6168,\n\ttext-primary: #1f2023,\n\tsupport-danger-default: #ee3939,\n\taccent-blue-primary: #3b9ef7,\n\tbackground-tertiary: #f7f9fc,\n\tprimary-default: #0c6dc7,\n\tborder-tertiary: #e3eaf2,\n\tbackground-primary: #ffffff,\n\taccent-blue-label: #ffffff,\n\tbackground-active: rgba(25, 138, 240, 0.1),\n\tborder-secondary: #c8d3e0,\n\tgrey-color-60: #9298a0,\n\tborder-primary: #91a0b5,\n\taccent-purple-primary: #944af5,\n\ttext-link: #1480e1,\n\tgreen-color-600: #75c322,\n\tlinear-bg: linear-gradient(135deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 50.52%),\n\toverlay-primary: rgba(36, 40, 46, 0.1),\n\tdark-box-shadow: rgba(0, 0, 0, 0.05),\n\topacity-neutral-10: rgba(145, 160, 181, 0.1),\n\tlinear-bg-2: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 100%),\n\tblue-color-100: #ecf5fe,\n\tlinear-bg-3: linear-gradient(180deg, rgba(255, 255, 255, 0) 25.21%, #fff 100%),\n\tborder-grey: rgba(255, 255, 255, 0.25),\n\tboxshadow-dark: rgba(0, 0, 0, 0.25),\n\tmain-dark: #000000,\n);\n\n:root {\n\t--primary-color-100: #d5eafc;\n\t--primary-color-200: #abd4fa;\n\t--primary-color-300: #80bff7;\n\t--primary-color-400: #3e9cf4;\n\t--primary-color-500: #1480e1; // connected\n\t--primary-color-600: #0c6dc7; // used\n\t--primary-color-700: #0a579f;\n\t--primary-color-800: #074177;\n\t--primary-color-900: #052c50;\n\t--primary-color-1000: #021628;\n\n\t--red-color-100: #ffebeb;\n\t--red-color-200: #ffcccc;\n\t--red-color-300: #ffb2b2;\n\t--red-color-400: #fa8989;\n\t--red-color-500: #f84f4f; // used\n\t--red-color-600: #ee3939;\n\t--red-color-700: #cc2937;\n\t--red-color-800: #992730;\n\t--red-color-900: #661414;\n\t--red-color-1000: #2f0404;\n\n\t--orange-color-100: #fff3eb;\n\t--orange-color-200: #ffe0cc;\n\t--orange-color-300: #ffd3b2;\n\t--orange-color-400: #fab784;\n\t--orange-color-500: #ff9433;\n\t--orange-color-600: #f26d0d;\n\t--orange-color-700: #c5591c;\n\t--orange-color-800: #9b4b1e;\n\t--orange-color-900: #663714;\n\t--orange-color-1000: #331500;\n\n\t--yellow-color-100: #fffaeb;\n\t--yellow-color-200: #fff2cc;\n\t--yellow-color-300: #ffecb2;\n\t--yellow-color-400: #fae08f;\n\t--yellow-color-500: #f7d53b;\n\t--yellow-color-600: #f5c400;\n\t--yellow-color-700: #d29700;\n\t--yellow-color-800: #b0820d;\n\t--yellow-color-900: #745302;\n\t--yellow-color-1000: #322401;\n\n\t--green-color-100: #f5feec;\n\t--green-color-200: #e5fccf;\n\t--green-color-300: #d5faaf;\n\t--green-color-400: #c1f091;\n\t--green-color-500: #96dd3c;\n\t--green-color-600: #75c322;\n\t--green-color-700: #5ba718;\n\t--green-color-800: #4e8b19;\n\t--green-color-900: #3f6614;\n\t--green-color-1000: #1a2b08;\n\n\t--blue-color-100: #ecf5fe;\n\t--blue-color-200: #cfe5fc;\n\t--blue-color-300: #afd6fa;\n\t--blue-color-400: #90caf5;\n\t--blue-color-500: #59aef8;\n\t--blue-color-600: #3b9ef7;\n\t--blue-color-700: #2b7bd4;\n\t--blue-color-800: #2a619d;\n\t--blue-color-900: #143f66;\n\t--blue-color-1000: #021b31;\n\n\t--purple-color-100: #f4ecfe;\n\t--purple-color-200: #e3cffc;\n\t--purple-color-300: #d0b0fb;\n\t--purple-color-400: #c198f8;\n\t--purple-color-500: #b06ef7;\n\t--purple-color-600: #944af5;\n\t--purple-color-700: #7231d7;\n\t--purple-color-800: #5828a1;\n\t--purple-color-900: #381466;\n\t--purple-color-1000: #160132;\n\n\t--neutral-color-0: #ffffff; // used\n\t--neutral-color-10: #f7f9fc; // used\n\t--neutral-color-20: #eef2f7;\n\t--neutral-color-30: #e3eaf2; // used\n\t--neutral-color-40: #c8d3e0;\n\t--neutral-color-50: #91a0b5;\n\t--neutral-color-60: #6c7a8b;\n\t--neutral-color-70: #4c5562;\n\t--neutral-color-80: #373d47;\n\t--neutral-color-90: #2d333b;\n\t--neutral-color-100: #24282e;\n\t--neutral-color-110: #191c1f; // used\n\t--neutral-color-120: #0d1011;\n\n\t--grey-color-10: #f5f6f7;\n\t--grey-color-20: #ebecef; // used\n\t--grey-color-30: #d7dade;\n\t--grey-color-40: #c2c7ce;\n\t--grey-color-50: #aeb5bd;\n\t--grey-color-60: #9298a0; // used\n\t--grey-color-70: #7b828a; // used\n\t--grey-color-80: #5c6168;\n\t--grey-color-90: #3e4145;\n\t--grey-color-100: #1f2023;\n\n\t--opacity-primary-10: rgba(25, 138, 240, 0.1);\n\t--opacity-primary-20: rgba(25, 138, 240, 0.2);\n\t--opacity-primary-30: rgba(25, 138, 240, 0.3);\n\t--opacity-primary-40: rgba(25, 138, 240, 0.4);\n\t--opacity-primary-50: rgba(25, 138, 240, 0.5);\n\t--opacity-primary-60: rgba(25, 138, 240, 0.6);\n\t--opacity-primary-70: rgba(25, 138, 240, 0.7);\n\t--opacity-primary-80: rgba(25, 138, 240, 0.8);\n\t--opacity-primary-90: rgba(25, 138, 240, 0.9);\n\n\t--opacity-red-10: rgba(242, 84, 84, 0.1);\n\t--opacity-red-20: rgba(242, 84, 84, 0.2);\n\t--opacity-red-30: rgba(242, 84, 84, 0.3);\n\t--opacity-red-40: rgba(242, 84, 84, 0.4);\n\t--opacity-red-50: rgba(242, 84, 84, 0.5);\n\t--opacity-red-60: rgba(242, 84, 84, 0.6);\n\t--opacity-red-70: rgba(242, 84, 84, 0.7);\n\t--opacity-red-80: rgba(242, 84, 84, 0.8);\n\t--opacity-red-90: rgba(242, 84, 84, 0.9);\n\n\t--opacity-neutral-10: rgba(145, 160, 181, 0.1);\n\t--opacity-neutral-20: rgba(145, 160, 181, 0.2);\n\t--opacity-neutral-30: rgba(145, 160, 181, 0.3);\n\t--opacity-neutral-40: rgba(145, 160, 181, 0.4);\n\t--opacity-neutral-50: rgba(145, 160, 181, 0.5);\n\n\t/* primary tokens */\n\t--primary-default: var(--primary-color-600); // used\n\t--primary-hover: var(--primary-color-700);\n\t--primary-active: var(--primary-color-800);\n\t--primary-disabled: var(--neutral-color-40);\n\n\t/* background */\n\t--background-primary: var(--neutral-color-0); // used\n\t--background-secondary: var(--neutral-color-0); // connected\n\t--background-tertiary: var(--neutral-color-10); // used\n\t--background-quaternary: var(--neutral-color-10);\n\t--background-quaternary: var(--neutral-color-30); // connected\n\t--background-hover: var(--opacity-neutral-10);\n\t--background-active: var(--opacity-primary-10);\n\t--background-disabled: var(--neutral-color-10);\n\t--background-tinted: var(--blue-color-100);\n\t--background-danger: var(--red-color-100);\n\t--background-danger-active: var(--opacity-red-10);\n\n\t/* border tokens  */\n\t--border-primary: var(--neutral-color-50);\n\t--border-secondary: var(--neutral-color-40);\n\t--border-tertiary: var(--neutral-color-30); // used\n\t--border-quaternary: var(--neutral-color-20);\n\t--border-hover: var(--primary-color-500); // connected\n\t--border-active: var(--primary-color-500); // connected\n\t--border-danger: var(--red-color-600);\n\t--border-disabled: var(--neutral-color-40);\n\n\t/* text tokens  */\n\t--text-primary: var(--grey-color-100); // used\n\t--text-secondary: var(--grey-color-70); // used\n\t--text-tertiary: var(--grey-color-60); // used\n\t--text-disabled: var(--neutral-color-40);\n\t--text-danger: var(--red-color-600);\n\t--text-on-color: var(--neutral-color-0); // connected\n\t--text-on-color-disabled: var(--neutral-color-0); // connected\n\t--text-link: var(--primary-color-500); //Z\n\n\t/* icon tokens  */\n\t--icon-primary: var(--neutral-color-60);\n\t--icon-emphasis: var(--neutral-color-110); // connected\n\t--icon-accent: var(--primary-color-500);\n\t--icon-disabled: var(--neutral-color-40);\n\t--icon-on-color: var(--neutral-color-0); // connected\n\t--icon-color-disabled: var(--neutral-color-0); // connected\n\n\t/* support tokens  */\n\t--support-danger-default: var(--red-color-600); // used\n\t--support-danger-hover: var(--red-color-700);\n\t--support-danger-active: var(--red-color-800);\n\t--support-approve-default: var(--green-color-600);\n\t--support-approve-hover: var(--green-color-700);\n\t--support-approve-active: var(--green-color-800);\n\n\t/* status tokens  */\n\t--status-success: var(--green-color-600);\n\t--status-warning: var(--yellow-color-600);\n\t--status-information: var(--blue-color-600);\n\t--status-danger: var(--red-color-600);\n\t--status-disabled: var(--neutral-color-50);\n\n\t/* Accent Tokens  */\n\t--accent-red-primary: var(--red-color-600);\n\t--accent-red-secondary: var(--red-color-300);\n\t--accent-red-tertiary: var(--red-color-100);\n\t--accent-red-label: var(--neutral-color-0); // connected\n\t--accent-orange-primary: var(--orange-color-600);\n\t--accent-orange-secondary: var(--orange-color-300);\n\t--accent-orange-tertiary: var(--orange-color-100);\n\t--accent-orange-label: var(--neutral-color-0); // connected\n\t--accent-yellow-primary: var(--yellow-color-600);\n\t--accent-yellow-secondary: var(--yellow-color-300);\n\t--accent-yellow-tertiary: var(--yellow-color-100);\n\t--accent-yellow-label: var(--neutral-color-0); // connected\n\t--accent-green-primary: var(--green-color-600);\n\t--accent-green-secondary: var(--green-color-300);\n\t--accent-green-tertiary: var(--green-color-100);\n\t--accent-green-label: var(--neutral-color-0); // connected\n\t--accent-blue-primary: var(--blue-color-600);\n\t--accent-blue-secondary: var(--blue-color-300);\n\t--accent-blue-tertiary: var(--blue-color-100);\n\t--accent-blue-label: var(--neutral-color-0); // conneced\n\t--accent-purple-primary: var(--purple-color-600);\n\t--accent-purple-secondary: var(--purple-color-300);\n\t--accent-purple-tertiary: var(--purple-color-100);\n\t--accent-purple-label: var(--neutral-color-0); // connected\n\t--accent-grey-primary: var(--neutral-color-50);\n\t--accent-grey-secondary: var(--neutral-color-30); // connected\n\t--accent-grey-tertiary: var(--neutral-color-10);\n\t--accent-grey-label: var(--neutral-color-0); // connected\n\n\t/* overlay tokens  */\n\t--overlay-primary: rgba(36, 40, 46, 0.1);\n\t--overlay-secondary: rgba(36, 40, 46, 0.3);\n}\n\n@media (prefers-color-scheme: dark) {\n\t:root {\n\t\t/* primary tokens */\n\t\t--primary-default: var(--primary-color-500); // used\n\t\t--primary-hover: var(--primary-color-600); // connected\n\t\t--primary-active: var(--primary-color-700);\n\t\t--primary-disabled: var(--neutral-color-80);\n\n\t\t/* background */\n\t\t--background-primary: var(--neutral-color-120); // used\n\t\t--background-secondary: var(--neutral-color-110); // connected\n\t\t--background-tertiary: var(--neutral-color-110); // used\n\t\t--background-quaternary: var(--neutral-color-100);\n\t\t--background-quaternary: var(--neutral-color-80);\n\t\t--background-hover: var(--opacity-neutral-10);\n\t\t--background-active: var(--opacity-primary-20);\n\t\t--background-disabled: var(--neutral-color-110); // connected\n\t\t--background-tinted: var(--blue-color-1000);\n\t\t--background-danger: var(--red-color-1000);\n\t\t--background-danger-active: var(--opacity-red-20);\n\n\t\t/* border tokens  */\n\t\t--border-primary: var(--neutral-color-60);\n\t\t--border-secondary: var(--neutral-color-80);\n\t\t--border-tertiary: var(--neutral-color-100); // used\n\t\t--border-quaternary: var(--neutral-color-110); // connected\n\t\t--border-hover: var(--primary-color-400);\n\t\t--border-active: var(--primary-color-400);\n\t\t--border-danger: var(--red-color-500); // connected\n\t\t--border-disabled: var(--neutral-color-80);\n\n\t\t/* text tokens  */\n\t\t--text-primary: var(--grey-color-20); // used\n\t\t--text-secondary: var(--grey-color-60); // used\n\t\t--text-tertiary: var(--grey-color-80);\n\t\t--text-disabled: var(--neutral-color-80);\n\t\t--text-danger: var(--red-color-500); // connected\n\t\t--text-on-color: var(--neutral-color-0); // connected\n\t\t--text-on-color-disabled: var(--neutral-color-120);\n\t\t--text-link: var(--primary-color-400);\n\n\t\t/* icon tokens  */\n\t\t--icon-primary: var(--grey-color-50);\n\t\t--icon-emphasis: var(--neutral-color-10);\n\t\t--icon-accent: var(--primary-color-400);\n\t\t--icon-disabled: var(--neutral-color-80);\n\t\t--icon-on-color: var(--neutral-color-0); // connected\n\t\t--icon-color-disabled: var(--neutral-color-80);\n\n\t\t/* support tokens  */\n\t\t--support-danger-default: var(--red-color-500); // used\n\t\t--support-danger-hover: var(--red-color-600);\n\t\t--support-danger-active: var(--red-color-700);\n\t\t--support-approve-default: var(--green-color-600);\n\t\t--support-approve-hover: var(--green-color-700);\n\t\t--support-approve-active: var(--green-color-800);\n\n\t\t/* status tokens  */\n\t\t--status-success: var(--green-color-500);\n\t\t--status-warning: var(--yellow-color-500);\n\t\t--status-information: var(--blue-color-500);\n\t\t--status-danger: var(--red-color-500); // connected\n\t\t--status-disabled: var(--neutral-color-50);\n\n\t\t/* Accent Tokens  */\n\t\t--accent-red-primary: var(--red-color-500); // connected\n\t\t--accent-red-secondary: var(--red-color-900);\n\t\t--accent-red-tertiary: var(--red-color-1000);\n\t\t--accent-red-label: var(--red-color-1000);\n\t\t--accent-orange-primary: var(--orange-color-500);\n\t\t--accent-orange-secondary: var(--orange-color-900);\n\t\t--accent-orange-tertiary: var(--orange-color-1000);\n\t\t--accent-orange-label: var(--orange-color-1000);\n\t\t--accent-yellow-primary: var(--yellow-color-500);\n\t\t--accent-yellow-secondary: var(--yellow-color-900);\n\t\t--accent-yellow-tertiary: var(--yellow-color-1000);\n\t\t--accent-yellow-label: var(--yellow-color-1000);\n\t\t--accent-green-primary: var(--green-color-500);\n\t\t--accent-green-secondary: var(--green-color-900);\n\t\t--accent-green-tertiary: var(--green-color-1000);\n\t\t--accent-green-label: var(--green-color-1000);\n\t\t--accent-blue-primary: var(--blue-color-500);\n\t\t--accent-blue-secondary: var(--blue-color-900);\n\t\t--accent-blue-tertiary: var(--blue-color-1000);\n\t\t--accent-blue-label: var(--blue-color-1000);\n\t\t--accent-purple-primary: var(--purple-color-500);\n\t\t--accent-purple-secondary: var(--purple-color-900);\n\t\t--accent-purple-tertiary: var(--purple-color-1000);\n\t\t--accent-purple-label: var(--purple-color-1000);\n\t\t--accent-grey-primary: var(--neutral-color-60);\n\t\t--accent-grey-secondary: var(--neutral-color-80);\n\t\t--accent-grey-tertiary: var(--neutral-color-100);\n\t\t--accent-grey-label: var(--neutral-color-100);\n\n\t\t/* overlay tokens  */\n\t\t--overlay-primary: rgba(13, 16, 17, 0.7);\n\t\t--overlay-secondary: rgba(13, 16, 17, 0.8);\n\t}\n}\n","@import \"./../abstracts/variables\";\n\n@font-face {\n\tfont-family: poppins_bold;\n\tsrc: url(\"./../../assets/fonts/Poppins/Poppins-Bold.ttf\");\n}\n\n@font-face {\n\tfont-family: poppins_semibold;\n\tsrc: url(\"./../../assets/fonts/Poppins/Poppins-SemiBold.ttf\");\n}\n\n@font-face {\n\tfont-family: poppins_medium;\n\tsrc: url(\"./../../assets/fonts/Poppins/Poppins-Medium.ttf\");\n}\n\n@font-face {\n\tfont-family: poppins_regular;\n\tsrc: url(\"./../../assets/fonts/Poppins/Poppins-Regular.ttf\");\n}\n\n* {\n\tpadding: 0px;\n\tmargin: 0px;\n\tbox-sizing: border-box !important;\n\tline-height: unset !important;\n\t-webkit-font-smoothing: auto;\n\t-moz-osx-font-smoothing: grayscale;\n}\n\nhtml,\nbody {\n\tfont-display: swap;\n\tfont-family: \"Poppins\";\n\tmax-width: 100vw;\n}\n\nul,\nli {\n\tlist-style: none;\n\tlist-style-type: none;\n}\n\nimg {\n\tvertical-align: middle;\n}\n\nbutton {\n\tcursor: pointer;\n\tbackground: none;\n\toutline: none;\n\tborder: none;\n}\n\na,\np,\nspan,\nli,\ndiv,\nbutton,\ninput,\ntextarea {\n\tfont-family: poppins_regular !important;\n}\n\ninput {\n\tborder: none;\n\tbackground: none;\n\tcolor: var(--text-primary);\n}\n\ntextarea {\n\tcolor: var(--text-primary);\n}\n\n/* Hide the number input arrow buttons */\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n\t-webkit-appearance: none;\n\tmargin: 0;\n}\n\ninput[type=\"number\"] {\n\t/* Optional: Define styles for appearance and cursor */\n\t-moz-appearance: textfield; /* Firefox */\n\tappearance: textfield; /* Other browsers */\n\tcursor: text;\n}\n\ntextarea {\n\tbackground: none;\n}\n\na {\n\ttext-decoration: none !important;\n}\n\np {\n\tmargin: 0;\n\tpadding: 0;\n}\n\n.Wrapper {\n\tmargin: auto;\n}\n\n.pagePopUp {\n\tposition: relative;\n\twidth: 100%;\n\theight: 100vh;\n\tz-index: 500;\n}\n\n.overlay {\n\twidth: 100vw;\n\theight: 100vh;\n\tflex-shrink: 0;\n\n\tbackground: var(--overlay-primary, rgba(36, 40, 46, 0.1));\n\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tz-index: 1000;\n\n\toverflow: hidden;\n}\n","@import \"./../abstracts/colors\";\n\n$themes: (\n\tdefault-primary: (\n\t\tlight: $primary-600,\n\t\tdark: $primary-500,\n\t),\n\tprimary-default: (\n\t\tlight: $primary-600,\n\t\tdark: $primary-500,\n\t),\n\n\tprimary-hover: (\n\t\tlight: $primary-700,\n\t\tdark: $primary-600,\n\t),\n\n\tprimary-active: (\n\t\tlight: $primary-800,\n\t\tdark: $primary-700,\n\t),\n\n\tprimary-disabled: (\n\t\tlight: $neutral-40,\n\t\tdark: $neutral-80,\n\t),\n\n\tprimary-rpm-default: (\n\t\tlight: $accent-green-700,\n\t\tdark: $accent-green-600,\n\t),\n\n\tprimary-rpm-hover: (\n\t\tlight: $accent-green-800,\n\t\tdark: $accent-green-700,\n\t),\n\n\tprimary-rpm-active: (\n\t\tlight: $accent-green-900,\n\t\tdark: $accent-green-800,\n\t),\n\n\tprimary-rpm-disabled: (\n\t\tlight: $neutral-40,\n\t\tdark: $neutral-80,\n\t),\n\n\tbackground-primary: (\n\t\tlight: $neutral-0,\n\t\tdark: $neutral-120,\n\t),\n\n\tbackground-secondary: (\n\t\tlight: $neutral-0,\n\t\tdark: $neutral-110,\n\t),\n\n\tbackground-tertiary: (\n\t\tlight: $neutral-10,\n\t\tdark: $neutral-110,\n\t),\n\n\tbackground-quaternary: (\n\t\tlight: $neutral-10,\n\t\tdark: $neutral-100,\n\t),\n\n\tbackground-emphasis: (\n\t\tlight: $neutral-30,\n\t\tdark: $neutral-80,\n\t),\n\n\tbackground-mixed: (\n\t\tlight: $neutral-30,\n\t\tdark: $neutral-100,\n\t),\n\n\tbackground-hover: (\n\t\tlight: $opacity-dark-10,\n\t\tdark: $opacity-dark-10,\n\t),\n\n\tbackground-active: (\n\t\tlight: $opacity-blue-10,\n\t\tdark: $opacity-blue-20,\n\t),\n\n\tbackground-rpm-active: (\n\t\tlight: $opacity-green-10,\n\t\tdark: $opacity-green-20,\n\t),\n\n\tbackground-disabled: (\n\t\tlight: $neutral-10,\n\t\tdark: $neutral-110,\n\t),\n\n\tbackground-tinted: (\n\t\tlight: $accent-blue-100,\n\t\tdark: $accent-blue-1000,\n\t),\n\n\tbackground-danger: (\n\t\tlight: $accent-red-100,\n\t\tdark: $accent-red-1000,\n\t),\n\n\tbackground-danger-active: (\n\t\tlight: $opacity-red-10,\n\t\tdark: $opacity-red-20,\n\t),\n\n\tbackground-emphasis-strong: (\n\t\tlight: $neutral-120,\n\t\tdark: $neutral-10,\n\t),\n\n\tborder-primary: (\n\t\tlight: $neutral-50,\n\t\tdark: $neutral-60,\n\t),\n\n\tborder-secondary: (\n\t\tlight: $neutral-40,\n\t\tdark: $neutral-80,\n\t),\n\n\tborder-tertiary: (\n\t\tlight: $neutral-30,\n\t\tdark: $neutral-100,\n\t),\n\n\tborder-quaternary: (\n\t\tlight: $neutral-20,\n\t\tdark: $neutral-110,\n\t),\n\n\tborder-hover: (\n\t\tlight: $primary-500,\n\t\tdark: $primary-400,\n\t),\n\n\tborder-active: (\n\t\tlight: $primary-500,\n\t\tdark: $primary-400,\n\t),\n\n\tborder-danger: (\n\t\tlight: $accent-red-600,\n\t\tdark: $accent-red-500,\n\t),\n\n\tborder-disabled: (\n\t\tlight: $neutral-40,\n\t\tdark: $neutral-80,\n\t),\n\n\ttext-primary: (\n\t\tlight: $grey-100,\n\t\tdark: $grey-20,\n\t),\n\n\ttext-secondary: (\n\t\tlight: $grey-70,\n\t\tdark: $grey-60,\n\t),\n\n\ttext-tertiary: (\n\t\tlight: $grey-60,\n\t\tdark: $grey-80,\n\t),\n\n\ttext-disabled: (\n\t\tlight: $neutral-40,\n\t\tdark: $neutral-80,\n\t),\n\n\ttext-danger: (\n\t\tlight: $accent-red-600,\n\t\tdark: $accent-red-500,\n\t),\n\n\ttext-on-color: (\n\t\tlight: $neutral-0,\n\t\tdark: $neutral-0,\n\t),\n\n\ttext-on-color-disabled: (\n\t\tlight: $neutral-0,\n\t\tdark: $neutral-120,\n\t),\n\n\ttext-link: (\n\t\tlight: $primary-500,\n\t\tdark: $primary-400,\n\t),\n\n\ticon-primary: (\n\t\tlight: $neutral-60,\n\t\tdark: $grey-50,\n\t),\n\n\ticon-emphasis: (\n\t\tlight: $neutral-110,\n\t\tdark: $neutral-10,\n\t),\n\n\ticon-accent: (\n\t\tlight: $primary-500,\n\t\tdark: $primary-400,\n\t),\n\n\ticon-disabled: (\n\t\tlight: $neutral-40,\n\t\tdark: $neutral-80,\n\t),\n\n\ticon-on-color: (\n\t\tlight: $neutral-0,\n\t\tdark: $neutral-0,\n\t),\n\n\ticon-color-disabled: (\n\t\tlight: $neutral-0,\n\t\tdark: $neutral-80,\n\t),\n\n\tsupport-danger: (\n\t\tlight: $accent-red-600,\n\t\tdark: $accent-red-500,\n\t),\n\n\tsupport-danger-default: (\n\t\tlight: $accent-red-600,\n\t\tdark: $accent-red-500,\n\t),\n\n\tsupport-danger-hover: (\n\t\tlight: $accent-red-700,\n\t\tdark: $accent-red-600,\n\t),\n\n\tsupport-danger-active: (\n\t\tlight: $accent-red-800,\n\t\tdark: $accent-red-700,\n\t),\n\n\tsupport-approve-default: (\n\t\tlight: $accent-green-600,\n\t\tdark: $accent-green-600,\n\t),\n\n\tsupport-approve-hover: (\n\t\tlight: $accent-green-700,\n\t\tdark: $accent-green-700,\n\t),\n\n\tsupport-approve-active: (\n\t\tlight: $accent-green-800,\n\t\tdark: $accent-green-800,\n\t),\n\n\tstatus-success: (\n\t\tlight: $accent-green-600,\n\t\tdark: $accent-green-500,\n\t),\n\n\tstatus-warning: (\n\t\tlight: $accent-yellow-600,\n\t\tdark: $accent-yellow-500,\n\t),\n\n\tstatus-information: (\n\t\tlight: $accent-blue-600,\n\t\tdark: $accent-blue-500,\n\t),\n\n\tstatus-danger: (\n\t\tlight: $accent-red-600,\n\t\tdark: $accent-red-500,\n\t),\n\n\tstatus-disabled: (\n\t\tlight: $neutral-50,\n\t\tdark: $neutral-50,\n\t),\n\n\taccent-red-primary: (\n\t\tlight: $accent-red-600,\n\t\tdark: $accent-red-500,\n\t),\n\n\taccent-red-secondary: (\n\t\tlight: $accent-red-300,\n\t\tdark: $accent-red-900,\n\t),\n\n\taccent-red-tertiary: (\n\t\tlight: $accent-red-100,\n\t\tdark: $accent-red-1000,\n\t),\n\n\taccent-red-label: (\n\t\tlight: $neutral-0,\n\t\tdark: $accent-red-1000,\n\t),\n\n\taccent-orange-primary: (\n\t\tlight: $accent-orange-600,\n\t\tdark: $accent-orange-500,\n\t),\n\n\taccent-orange-secondary: (\n\t\tlight: $accent-orange-300,\n\t\tdark: $accent-orange-900,\n\t),\n\n\taccent-orange-tertiary: (\n\t\tlight: $accent-orange-100,\n\t\tdark: $accent-orange-1000,\n\t),\n\n\taccent-orange-label: (\n\t\tlight: $neutral-0,\n\t\tdark: $accent-orange-1000,\n\t),\n\n\taccent-yellow-primary: (\n\t\tlight: $accent-yellow-600,\n\t\tdark: $accent-yellow-500,\n\t),\n\n\taccent-yellow-secondary: (\n\t\tlight: $accent-yellow-300,\n\t\tdark: $accent-yellow-900,\n\t),\n\n\taccent-yellow-tertiary: (\n\t\tlight: $accent-yellow-100,\n\t\tdark: $accent-yellow-1000,\n\t),\n\n\taccent-yellow-label: (\n\t\tlight: $neutral-0,\n\t\tdark: $accent-yellow-1000,\n\t),\n\n\taccent-green-primary: (\n\t\tlight: $accent-green-600,\n\t\tdark: $accent-green-500,\n\t),\n\n\taccent-green-secondary: (\n\t\tlight: $accent-green-300,\n\t\tdark: $accent-green-900,\n\t),\n\n\taccent-green-tertiary: (\n\t\tlight: $accent-green-100,\n\t\tdark: $accent-green-1000,\n\t),\n\n\taccent-green-label: (\n\t\tlight: $neutral-0,\n\t\tdark: $accent-green-1000,\n\t),\n\n\taccent-blue-primary: (\n\t\tlight: $accent-blue-600,\n\t\tdark: $accent-blue-500,\n\t),\n\n\taccent-blue-secondary: (\n\t\tlight: $accent-blue-300,\n\t\tdark: $accent-blue-800,\n\t),\n\n\taccent-blue-tertiary: (\n\t\tlight: $accent-blue-100,\n\t\tdark: $accent-blue-1000,\n\t),\n\n\taccent-blue-label: (\n\t\tlight: $neutral-0,\n\t\tdark: $accent-blue-1000,\n\t),\n\n\taccent-purple-primary: (\n\t\tlight: $accent-purple-600,\n\t\tdark: $accent-purple-500,\n\t),\n\n\taccent-purple-secondary: (\n\t\tlight: $accent-purple-300,\n\t\tdark: $accent-purple-900,\n\t),\n\n\taccent-purple-tertiary: (\n\t\tlight: $accent-purple-100,\n\t\tdark: $accent-purple-1000,\n\t),\n\n\taccent-purple-label: (\n\t\tlight: $neutral-0,\n\t\tdark: $accent-purple-1000,\n\t),\n\n\taccent-grey-primary: (\n\t\tlight: $neutral-50,\n\t\tdark: $neutral-60,\n\t),\n\n\taccent-grey-secondary: (\n\t\tlight: $neutral-30,\n\t\tdark: $neutral-80,\n\t),\n\n\taccent-grey-tertiary: (\n\t\tlight: $neutral-10,\n\t\tdark: $neutral-100,\n\t),\n\n\taccent-grey-label: (\n\t\tlight: $neutral-0,\n\t\tdark: $neutral-100,\n\t),\n\n\toverlay-primary: (\n\t\tlight: $opacity-neutral-100-10,\n\t\tdark: $opacity-neutral-120-70,\n\t),\n\n\toverlay-secondary: (\n\t\tlight: $opacity-neutral-100-30,\n\t\tdark: $opacity-neutral-120-80,\n\t),\n\n\thover-primary: (\n\t\tlight: $grey-hover-light1,\n\t\tdark: $grey-hover-dark2,\n\t),\n\n\tscroll-primary: (\n\t\tlight: $grey-scroll-light,\n\t\tdark: $grey-scroll-dark,\n\t),\n\tbox-shadow-primary: (\n\t\tlight: $neutral-30,\n\t\tdark: $neutral-110,\n\t),\n\tcard-green-hover: (\n\t\tlight: $accent-green-600,\n\t\tdark: $accent-green-900,\n\t),\n\tcard-green: (\n\t\tlight: $accent-green-100,\n\t\tdark: $accent-green-100,\n\t),\n\tcard-light-green: (\n\t\tlight: $neutral-30,\n\t\tdark: $neutral-110,\n\t),\n\tcard-white: (\n\t\tlight: $neutral-30,\n\t\tdark: $neutral-110,\n\t),\n\tcard-gray: (\n\t\tlight: $neutral-30,\n\t\tdark: $neutral-110,\n\t),\n);\n\n@mixin styles($mode) {\n\t@each $key, $map in $themes {\n\t\t@each $prop, $color in $map {\n\t\t\t@if $prop == $mode {\n\t\t\t\t--#{$key}: #{$color};\n\t\t\t}\n\t\t}\n\t}\n}\n\n.light-mode {\n\t@include styles(\"light\");\n}\n\n.dark-mode {\n\t@include styles(\"dark\");\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Wrapper": `StatusMenu_Wrapper__FNkQJ`,
	"pagePopUp": `StatusMenu_pagePopUp__7o0Sl`,
	"overlay": `StatusMenu_overlay__VTkA5`,
	"light-mode": `StatusMenu_light-mode__x5xCS`,
	"dark-mode": `StatusMenu_dark-mode__GEBxk`,
	"profileMenu": `StatusMenu_profileMenu__Tp4js`,
	"profileBox": `StatusMenu_profileBox__D+OEC`,
	"slideIn": `StatusMenu_slideIn__sm8yz`,
	"headline": `StatusMenu_headline__X9ppn`,
	"heading": `StatusMenu_heading__IzZWX`,
	"status": `StatusMenu_status__DfEQ8`,
	"status_type": `StatusMenu_status_type__vQ01e`,
	"status_type_active": `StatusMenu_status_type_active__w2i4D`,
	"clearStatus": `StatusMenu_clearStatus__pE5NK`,
	"slideFromRight": `StatusMenu_slideFromRight__4tlqo`
};
export default ___CSS_LOADER_EXPORT___;
